import { useClipboard } from '@/hooks/useClipboard';
import { ClipboardDocumentIcon, CheckIcon } from '@/icons';
import { cn } from '@/lib/cn';

/** Read-only value with a copy button — used for DNS records, keys, etc. */
export function CopyableField({ label, value, mono = true }: { label?: string; value: string; mono?: boolean }) {
  const { copied, copy } = useClipboard();
  return (
    <div>
      {label && <p className="mb-1 text-xs font-medium text-fg-muted">{label}</p>}
      <div className="flex items-center gap-2 rounded-lg border border-border bg-surface-raised/40 px-3 py-2">
        <code className={cn('flex-1 truncate text-sm text-fg', mono && 'font-mono')}>{value}</code>
        <button
          type="button"
          onClick={() => copy(value)}
          className="shrink-0 rounded p-1 text-fg-subtle hover:bg-surface-raised hover:text-fg"
          aria-label={copied ? 'Copied' : 'Copy to clipboard'}
        >
          {copied ? <CheckIcon className="h-4 w-4 text-success" /> : <ClipboardDocumentIcon className="h-4 w-4" />}
        </button>
      </div>
    </div>
  );
}
